import React, { useState } from 'react';
import { Drawer, Button } from 'antd';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import NavBar from './NavBar';
import Sidebar from './Sidebar';
import FooterLayout from './Footer';
import './css/index.css';
import SidebarC from './Sidebar';
import SidebarAdmin from './SidebarAdmin';
import logo from '../assets/images/paxity-logo-sidebar.png'



const LayoutIndexAdmin = ({ children }) => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
  const isAdmin = currentUser?.roles?.includes("ADMIN");
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="layout-admin">
      
      <aside className="sidebar desktop-sidebar">
         {/* Sidebar desktop */}
      <Sidebar/>
      </aside>
        {/* Drawer mobile */}

<Drawer
  placement="left"
  closable={false} // on gère le bouton close nous-mêmes
  onClose={() => setIsSidebarOpen(false)}
  open={isSidebarOpen}
  width={235}
  bodyStyle={{
    padding: 0,
    height: '100%',
    backgroundColor: '#4379F2',
  }}
>
  {/* ✅ Header personnalisé */}
  <div className="drawer-header-custom">
    <img src={logo} alt="Logo" className="drawer-logo" />
    <Button
      type="text"
      icon={<CloseOutlined />}
      onClick={() => setIsSidebarOpen(false)}
      className="drawer-close-btn"
    />
  </div>

  {/* ✅ Ton sidebar existant (inchangé) */}
  <SidebarAdmin
    isAdmin={isAdmin}
    onLinkClick={() => setIsSidebarOpen(false)}
  />
</Drawer>

      {/* Navbar */}
     <header className="navbar-admin">
  {/* Bouton Menu à gauche */}
  <Button
    className="menu-toggle"
    type="text"
    icon={<MenuOutlined style={{ fontSize: 20 }} />}
    onClick={toggleSidebar}
  />
  <header className="navbar-admin">
  {/* Bouton Menu à gauche */}
  <Button
    className="menu-toggle"
    type="text"
    icon={<MenuOutlined style={{ fontSize: 20 }} />}
    onClick={toggleSidebar}
  />
  
  {/* Contenu de la navbar */}
  <NavBar />
</header>
</header>


      {/* Main content */}
      <div className="main-admin">
        <main className="content-admin">{children}</main>
        <footer className="footer-admin">
          <FooterLayout />
        </footer>
      </div>
    </div>
  );
};

export default LayoutIndexAdmin;
